/** Action ids for the Bulk Toggle dropdown on the NAR Agent Grid table. */
export enum NarAgentGridBulkToggleAction {
  AgentMode = "agentMode",
  AutoPassReviewMode = "autoPassReviewMode",
  Both = "both",
}

export const NAR_AGENT_GRID_BULK_TOGGLE_BUTTON_LABEL = "Bulk Toggle";

export const NAR_AGENT_GRID_BULK_TOGGLE_MENU_ITEMS: ReadonlyArray<{
  id: NarAgentGridBulkToggleAction;
  label: string;
}> = [
  {
    id: NarAgentGridBulkToggleAction.AgentMode,
    label: "Agent Mode",
  },
  {
    id: NarAgentGridBulkToggleAction.AutoPassReviewMode,
    label: "AutoPass Review Mode",
  },
  {
    id: NarAgentGridBulkToggleAction.Both,
    label: "Both",
  },
];
